import { Row } from 'react-table';
import { AdaptoActions } from '@frontend/adapto-actions';
import { useTranslation } from '@frontend/i18n';
import { RecentCallRecord } from '@frontend/phone-panels';
import { theme } from '@frontend/theme';
import { useCallHistoryCallInsight } from '../../hooks/use-call-history-call-insight';
import { trackingId } from '../../pendo-tracking';

export const ViewCallDetailsColumn = ({
  row,
  showCallIntelInsights,
  hoverLabel,
  isEdited = false,
  registerClick,
}: {
  row: Row<RecentCallRecord>;
  showCallIntelInsights: boolean;
  hoverLabel?: string;
  isEdited?: boolean;
  registerClick: () => void;
}) => {
  const { t } = useTranslation('calls');

  const { open: openCallInsightPanel } = useCallHistoryCallInsight();

  return (
    <AdaptoActions.Action
      icon={isEdited ? 'document-sent' : 'document-filled'}
      aria-label={t('View call details')}
      onClick={() => {
        openCallInsightPanel(
          { hydratedCall: row.original },
          { defaultAccordion: 'callIntel', trackingContext: { source: 'recent-calls-table' } }
        );
        // Register custom event to reset call details panel
        document.getElementById('call-details-panel')?.dispatchEvent(new Event('reset-panel'));
        registerClick();
      }}
      color={
        isEdited ? theme.font.colors.success : row.isSelected ? theme.font.colors.primary : theme.font.colors.light
      }
      trackingId={trackingId({
        component: 'recentCalls',
        context: showCallIntelInsights ? 'table::panel-trigger-with-callintel' : 'table::panel-trigger',
      })}
      hoverLabel={hoverLabel}
    />
  );
};
